import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import Menu_Items from '../Menu_Items';
import { AiOutlineMergeCells } from "react-icons/ai";
import { MdAddToPhotos } from "react-icons/md";
import { IoClose } from "react-icons/io5";


function MergeTables() {
  const { id, int_id, Ex_id } = useParams();

  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [monitor, setmonitor] = useState(false)
  const [tables, settables] = useState([]);
  const [headers, setheaders] = useState({});
  const [linkdivs, setlinkdivs] = useState(['div']);
  const [mergeTable, setmergeTable] = useState([]);


  const menus = [
    {
      name: 'Integrations',
      id,
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'Out Bound', id, int_id, Ex_id },
      { name: 'Conditions', id, int_id, Ex_id },
      { name: 'Linked Tables', id, int_id, Ex_id },
      { name: 'Merge Tables', id, int_id, Ex_id },
      { name: 'Result', id, int_id, Ex_id },
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
    else {
      setmonitor(true)
    }
  };
  const getOutBound = async () => {
    await axios.get(`/out_bound/export_value/${Ex_id}`).then(res => {
      const response = res.data;
      if (response.Headers) {
        const headers = JSON.parse(response.Headers);
        const merged = Object.assign({}, ...headers);
        const Tables = Object.keys(merged);
        settables(Tables)
        Tables.map(table => {
          merged[table] = merged[table].map(obj => obj.alias)
        });
        setheaders(merged)
        // console.log(merged);
      }
      if (response.Merge_Table) {
        const Merge_Table = JSON.parse(response.Merge_Table);
        setmergeTable(Merge_Table);
      }
    }).catch((err) => {
      toast.error("get out_bound error", {
        autoClose: 2000, // 2 seconds
      });
    })
  };
  const MergeOption = (i) => {
    const match = mergeTable[i]?.MainTable;
    if (match) {
      return tables.filter(table => table !== match)
    }
    return []
  };
  const getOptions = (i) => {
    const match = mergeTable[i]?.MergeTable;
    if (match) {
      return headers[match]
    }
    return []
  };
  const handleLinkTable = (i, key, value) => {
    setmergeTable((prev) => {
      if (i < prev.length) {
        // update existing item
        return prev.map((obj, index) => {
          if (index === i) {
            return { ...obj, [key]: value };
          }
          return obj;
        });
      } else {
        // add new item (if prev is empty or i is out of bounds)
        return [...prev, { [key]: value }];
      }
    });
  };
  const closediv = (i) => {
    const length = linkdivs.length === 1
    if (length) {
      setmergeTable(prev => prev.filter((_, index) => index !== i))
    } else {
      setlinkdivs(prev => prev.filter((_, index) => index !== i))
      setmergeTable(prev => prev.filter((_, index) => index !== i))
    }
  };
  const Submit = async () => {
    const data = {
      Merge_Table: JSON.stringify(mergeTable)
    }
    await axios.patch(`/out_bound/mergetable/${Ex_id}`, data).then((res) => {
      toast.success("Merge Table Conditions Updated", {
        autoClose: 2000, // 2 seconds
      });
    }).catch((err) => {
      toast.error("out_bound mergetable update error", {
        autoClose: 2000, // 2 seconds
      });
    });
    // console.log(mergeTable);
    // console.log(values);
  };
  useEffect(() => {
    get_level()
    getOutBound()
  }, []);
  return (
    <div className='container df fdc jb ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac of_h'>
          <div className='page_header df jb ac'>
            <div className='w90 h5 df ac'>
              <AiOutlineMergeCells className='page_icon db' />
              <p>Merge Tables</p>
            </div>
            <div className='w10 h6 df jc ac'>
              <MdAddToPhotos className='h3 w30 g' onClick={() => setlinkdivs([...linkdivs, 'div'])} />
            </div>
          </div>
          <div className='h75 w100 df fdc ac of_a white'>
            {
              linkdivs.map((div, index) => {
                return (
                  <div className='h10 w95 df js ac' key={index}>
                    <div className='h7 w15 df fdc'>
                      <label>Main Table</label>
                      <select className='h4' value={mergeTable[index]?.MainTable || ''} onChange={(e) => { handleLinkTable(index, 'MainTable', e.target.value) }}>
                        <option value={''}>Select Table</option>
                        {
                          tables.length > 0 && tables.map((table, index) => (
                            <option value={table} key={index}>{table}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='h7 w15 df fdc'>
                      <label>Merge Table</label>
                      <select className='h4' value={mergeTable[index]?.MergeTable || ''} onChange={(e) => { handleLinkTable(index, 'MergeTable', e.target.value) }}>
                        <option value={''}>Select Table</option>
                        {
                          MergeOption(index).length > 0 && MergeOption(index).map((table, index) => (
                            <option value={table} key={index}>{table}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='h7 w15 df fdc'>
                      <label>Match Field</label>
                      <select className='h4' value={mergeTable[index]?.MatchField || ''} onChange={(e) => { handleLinkTable(index, 'MatchField', e.target.value) }}>
                        <option value={''}>Select Field</option>
                        {
                          getOptions(index).length > 0 && getOptions(index).map((name, ind) => (
                            <option key={ind} value={name}>{name}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='h7 w15 df fdc'>
                      <label>Header</label>
                      <select className='h4' value={mergeTable[index]?.Header || ''} onChange={(e) => { handleLinkTable(index, 'Header', e.target.value) }}>
                        <option value={''}>Select Header</option>
                        {
                          getOptions(index).length > 0 && getOptions(index).map((name, ind) => (
                            <option key={ind} value={name}>{name}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='h7 w15 df fdc'>
                      <label>Match Value</label>
                      <select className='h4' value={mergeTable[index]?.Value || ''} onChange={(e) => { handleLinkTable(index, 'Value', e.target.value) }}>
                        <option value={''}>Select Value</option>
                        {
                          getOptions(index).length > 0 && getOptions(index).map((name, ind) => (
                            <option key={ind} value={name}>{name}</option>
                          ))
                        }
                      </select>
                    </div>
                    <div className='h7 df jc ac'>
                      <IoClose className='r' onClick={() => { closediv(index) }} />
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className='h8 w100 df jc ac white'>
            <button className='btn green' onClick={Submit}>Submit</button>
          </div>
        </div>
      </div>
    </div >
  )
}

export default MergeTables